(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[966],{

/***/ 55670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ captureUnderscoreErrorException; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92642);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63699);



/** Platform-agnostic version of `flush` */
function flush(timeout) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  return client ? client.flush(timeout) : Promise.resolve(false);
}

/**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */
async function captureUnderscoreErrorException(contextOrProps) {
  const { req, res, err } = contextOrProps;

  // 404s (and other 400-y friends) can trigger `_error`, but we don't want to send them to Sentry
  const statusCode = (res && res.statusCode) || contextOrProps.statusCode;
  if (statusCode && statusCode < 500) {
    return Promise.resolve();
  }

  // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
  // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
  // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
  // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
  // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
  // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
  // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
  if (!contextOrProps.pathname) {
    return Promise.resolve();
  }

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .$e)(scope => {
    scope.addEventProcessor(event => {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addExceptionMechanism */ .EG)(event, {
        type: 'instrument',
        handled: false,
        data: {
          function: '_error.getInitialProps',
        },
      });
      return event;
    });

    if (req) {
      scope.setSDKProcessingMetadata({ request: req });
    }

    // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
    // is what passing a string to `captureException` will wind up doing)
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(err || `_error.js called with falsy error (${err})`);
  });

  // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
  // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
  await flush(2000);
}


//# sourceMappingURL=_error.js.map


/***/ }),

/***/ 32907:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return __webpack_require__(5500);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(38726);
// EXTERNAL MODULE: ./src/components/account/accountInformation/styles.ts
var styles = __webpack_require__(41059);
// EXTERNAL MODULE: ./src/components/checkout/uielements/index.tsx
var uielements = __webpack_require__(66);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/components/account/accountInformation/referralCode.tsx








var containerId = "referral-code-container";
var _ReferralCode = function(param) {
    var me = param.me;
    var ref = (0,react.useState)(null), copied = ref[0], setCopied = ref[1];
    (0,react.useEffect)(function() {
        // Copy code to clipboard and display 'Copied!' message
        if (copied) {
            // @ts-expect-error ensure that `copied` is defined.
            (0,global/* copyToClipboard */.vQ)(copied).catch(function(error) {
                return console.log(error);
            });
            // Remove message after 3 seconds
            setTimeout(function() {
                return setCopied(null);
            }, 3000);
        }
    }, [
        copied
    ]);
    // Only display if referral code exists
    if (!(me === null || me === void 0 ? void 0 : me.referral_code)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepContent */.rY, {
        enabled: true,
        "data-testid": containerId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledAccountInfoContainer */.S, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "account.referral_code_instructions_header",
                    tag: uielements/* StyledSubheaderText */.le
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "account.referral_code_instructions",
                    tag: styles/* StyledReferralCodeInstructions */.f6
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledReferralCodeContent */._A, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledReferralCode */.xw, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    tag: "p",
                                    accessor: "account.referral_code_header"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledBoxShadowText */.k6, {
                                    children: me.referral_code
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledButtonContainer */.qt, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton_styles/* StyledPrimaryButton */.D, {
                                    size: "small",
                                    onClick: function() {
                                        return setCopied(me.referral_code);
                                    },
                                    children: "Copy"
                                }),
                                (0,global/* copyToClipboard */.vQ)(copied) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledCopiedText */.If, {
                                    children: "Copied!"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        me: state.app.me.data
    };
};
var connector = (0,es.connect)(mapStateToProps);
var ReferralCode = connector(_ReferralCode);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/account/styles.ts
var account_styles = __webpack_require__(99736);
// EXTERNAL MODULE: ./src/components/account/accountInformation/favoriteLocation/form.tsx
var favoriteLocation_form = __webpack_require__(70064);
// EXTERNAL MODULE: ./src/components/featureAccessor/index.tsx
var featureAccessor = __webpack_require__(88917);
// EXTERNAL MODULE: ./src/components/locations/card/index.tsx + 10 modules
var card = __webpack_require__(93483);
// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var actions = __webpack_require__(47290);
;// CONCATENATED MODULE: ./src/components/account/accountInformation/favoriteLocation/index.tsx















var favoriteLocation_containerId = "favorite-location-container";
var _FavoriteLocation = function(param) {
    var meFavoriteLocations = param.meFavoriteLocations, fetchMeFavoriteLocations = param.fetchMeFavoriteLocations;
    (0,react.useEffect)(function() {
        fetchMeFavoriteLocations();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
        featureFlag: features/* FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */.y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements/* StyledStepContent */.rY, {
            "data-testid": favoriteLocation_containerId,
            enabled: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledAccountInfoContainer */.S, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledSubheaderText */.le, {
                        children: "Favorite Location"
                    })
                }),
                meFavoriteLocations && meFavoriteLocations.length ? meFavoriteLocations.map(function(location) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* LocationCard */.b, {
                        location: location,
                        favorites: true,
                        editFavoriteLocation: true
                    }, location.id);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                    trigger: function(open) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                            onClick: open,
                            bold: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "account.add_favorite_location_button",
                                tag: styles/* StyledReferralCodeInstructions */.f6
                            })
                        });
                    },
                    children: function(toggle) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(favoriteLocation_form/* FavoriteLocationForm */.j, {
                            onToggle: toggle
                        });
                    }
                })
            ]
        })
    });
};
var favoriteLocation_mapStateToProps = function(state) {
    return {
        meFavoriteLocations: state.app.me.favoriteLocations
    };
};
var mapDispatchToProps = {
    fetchMeFavoriteLocations: actions/* default.fetchMeFavoriteLocations */.Z.fetchMeFavoriteLocations
};
var favoriteLocation_connector = (0,es.connect)(favoriteLocation_mapStateToProps, mapDispatchToProps);
var FavoriteLocation = (0,redux/* compose */.qC)(styled_components_browser_esm/* withTheme */.Zz, favoriteLocation_connector)(_FavoriteLocation);

// EXTERNAL MODULE: ./src/components/uielements/reward/styles.tsx
var reward_styles = __webpack_require__(135);
// EXTERNAL MODULE: ./src/constants/authentication.ts
var authentication = __webpack_require__(5125);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/organization/reducer.ts
var reducer = __webpack_require__(63212);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
;// CONCATENATED MODULE: ./src/components/account/accountInformation/index.tsx










var accountInformation_containerId = "account-information-container";
var headerContainerId = "account-information-header-container";
var AccountInformation = function() {
    var ref;
    var webConfig = (0,cmsConfig/* useWebConfig */.JR)();
    var organization = (0,es.useSelector)(reducer/* organizationSliceSelector */.F5);
    var isFavoriteLocationEnabled = webConfig.accounts.favorite_location !== "disabled";
    var organizationConsentFields = (0,auth/* getSignupOptionalFields */.A5)(organization === null || organization === void 0 ? void 0 : (ref = organization.organization) === null || ref === void 0 ? void 0 : ref.loyalty_driver_id);
    var referralCodeEnabled = webConfig.accounts.punchh_referral_code_field && organizationConsentFields.includes(authentication/* SIGNUP_OPTIONAL_FIELDS.REFERRAL_CODE */.ZV.REFERRAL_CODE);
    if (!referralCodeEnabled && !isFavoriteLocationEnabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements/* StyledCheckoutComponent */.Sn, {
        "data-testid": accountInformation_containerId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepHeader */.k$, {
                "data-testid": headerContainerId,
                enabled: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledHeaderText */.jc, {
                    children: "Account Information"
                })
            }),
            referralCodeEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferralCode, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledBorderBottom */.Ot, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteLocation, {})
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(65413);
// EXTERNAL MODULE: ./src/components/checkout/uielements/primaryButton/index.tsx
var primaryButton = __webpack_require__(84899);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var form_fields_styles = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/components/uielements/formik/index.tsx + 3 modules
var formik = __webpack_require__(83269);
// EXTERNAL MODULE: ./src/constants/validation.ts
var validation = __webpack_require__(38885);
// EXTERNAL MODULE: ./src/redux/index.ts
var src_redux = __webpack_require__(86879);
;// CONCATENATED MODULE: ./src/components/account/personalInformation/form.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ContactInfoForm = function(param) {
    var close = param.close;
    var dispatch = (0,src_redux/* useDispatch */.I0)();
    var ref = (0,src_redux/* useSelector */.v9)(function(state) {
        return state.app.me;
    }), data = ref.data, loading = ref.loading;
    var externalAuth = (0,src_redux/* useSelector */.v9)(function(state) {
        return state.app.organization.external_auth;
    });
    var webConfig = (0,src_redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var isZipCodeEnabledAndDisplayed = webConfig.accounts.zip_code !== "disabled" && (data === null || data === void 0 ? void 0 : data.zip_code) !== null;
    var updatableFields = externalAuth.updatable_fields.user;
    var readOnlyFields = externalAuth.readonly_fields.user;
    var ref1, ref2, ref3, ref4, ref5;
    var initialValues = {
        first_name: (ref1 = data === null || data === void 0 ? void 0 : data.first_name) !== null && ref1 !== void 0 ? ref1 : "",
        last_name: (ref2 = data === null || data === void 0 ? void 0 : data.last_name) !== null && ref2 !== void 0 ? ref2 : "",
        email: (ref3 = data === null || data === void 0 ? void 0 : data.email) !== null && ref3 !== void 0 ? ref3 : "",
        phone: (ref4 = data === null || data === void 0 ? void 0 : data.phone) !== null && ref4 !== void 0 ? ref4 : "",
        zip_code: (ref5 = data === null || data === void 0 ? void 0 : data.zip_code) !== null && ref5 !== void 0 ? ref5 : ""
    };
    // Validation schema for the reset form.
    var contactInfoSchema = (0,yup_es/* object */.Ry)({
        first_name: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED),
        last_name: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED),
        email: (0,yup_es/* string */.Z_)().email(validation/* VALIDATION_STRINGS.EMAIL */.xz.EMAIL).required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED),
        phone: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED).matches(validation/* REGEX.PHONE */.mL.PHONE, validation/* REGEX_VALIDATION_STRINGS.PHONE */.r7.PHONE),
        zip_code: (0,yup_es/* lazy */.Vo)(function() {
            return isZipCodeEnabledAndDisplayed ? (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED).matches(validation/* REGEX.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA */.mL.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA, {
                message: validation/* REGEX_VALIDATION_STRINGS.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA */.r7.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA
            }) : (0,yup_es/* string */.Z_)().optional();
        })
    });
    var isFieldDisabled = function(name) {
        return readOnlyFields.includes(name) || !updatableFields.includes(name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: function(formValues, param) {
            var resetForm = param.resetForm;
            dispatch(actions/* default.updateMe */.Z.updateMe(formValues));
            resetForm();
            close();
        },
        initialValues: initialValues,
        validationSchema: contactInfoSchema,
        children: function(param) {
            var dirty = param.dirty, isValid = param.isValid;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik/* Form */.l, {
                "data-testid": "contact-info-form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            label: "",
                            id: "first_name",
                            name: "first_name",
                            placeholder: "First Name",
                            type: "text",
                            disabled: isFieldDisabled("first_name")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            label: "",
                            id: "last_name",
                            name: "last_name",
                            placeholder: "Last Name",
                            type: "text",
                            disabled: isFieldDisabled("last_name")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            label: "",
                            id: "email",
                            name: "email",
                            placeholder: "Email",
                            type: "text",
                            disabled: isFieldDisabled("email")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            label: "",
                            id: "phone",
                            name: "phone",
                            type: "tel",
                            placeholder: "Phone Number",
                            disabled: isFieldDisabled("phone")
                        })
                    }),
                    isZipCodeEnabledAndDisplayed && (data === null || data === void 0 ? void 0 : data.zip_code) !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            label: "",
                            id: "zip_code",
                            name: "zip_code",
                            type: "text",
                            placeholder: "Zip Code",
                            maxLength: 10,
                            disabled: isFieldDisabled("zip_code")
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CancelAndSubmitButtons, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledCancelEdit */.Mo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                                    onClick: close,
                                    "aria-label": "Hide personal info form",
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                                type: "submit",
                                theme: "secondary",
                                submitting: loading,
                                handleClick: function() {
                                    return null;
                                },
                                minWidth: 150,
                                disabled: !dirty || !isValid,
                                "aria-label": "Submit Updated Contact Info",
                                children: loading ? "Loading" : "Submit"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var CancelAndSubmitButtons = (0,styled_components_browser_esm/* default */.ZP)(account_styles/* StyledCancelAndSubmitButtons */.VX).withConfig({
    componentId: "sc-83618f97-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
;// CONCATENATED MODULE: ./src/components/account/personalInformation/index.tsx











var ContactInformation = function() {
    var dispatch = (0,es.useDispatch)();
    var ref = (0,react.useState)(false), isFormOpened = ref[0], setIsFormOpened = ref[1];
    var me = (0,src_redux/* useSelector */.v9)(function(root) {
        return root.app.me.data;
    });
    var webConfig = (0,src_redux/* useSelector */.v9)(function(root) {
        return root.app.cmsConfig.webConfig;
    });
    var zipCodeEnabled = webConfig.accounts.zip_code !== "disabled";
    (0,react.useEffect)(function() {
        if (!me) {
            dispatch(actions/* default.fetchMe */.Z.fetchMe());
        }
    }, [
        me
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements/* StyledCheckoutComponent */.Sn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepHeader */.k$, {
                enabled: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "account.contact_info_header",
                    tag: uielements/* StyledHeaderText */.jc
                })
            }),
            isFormOpened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepContent */.rY, {
                enabled: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfoForm, {
                    close: function() {
                        return setIsFormOpened(false);
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledContactInfoContainer */.$3, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledContactInfoContent */.Ji, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        me === null || me === void 0 ? void 0 : me.first_name,
                                        " ",
                                        me === null || me === void 0 ? void 0 : me.last_name
                                    ]
                                }),
                                (me === null || me === void 0 ? void 0 : me.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: me.email
                                }),
                                (me === null || me === void 0 ? void 0 : me.phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: (0,auth/* phoneNumberFormatter */.ni)(me.phone)
                                }),
                                zipCodeEnabled && (me === null || me === void 0 ? void 0 : me.zip_code) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: me.zip_code
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                            onClick: function() {
                                setIsFormOpened(true);
                                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.account */.m1.account, googleAnalytics/* gaActions.editContactInfo */.cE.editContactInfo);
                            },
                            bold: true,
                            "aria-label": "Click to edit personal info",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "account.contact_info_edit_button"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs + 4 modules
var dist = __webpack_require__(44428);
// EXTERNAL MODULE: ./src/components/account/uielements/index.tsx + 1 modules
var account_uielements = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/components/uielements/css.ts
var css = __webpack_require__(64390);
// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/account/storedAddresses/menu/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  background: ",
        ";\n  position: relative;\n  bottom: ",
        "px;\n  right: 0;\n  z-index: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: ",
        ";\n  padding: ",
        "px ",
        "px;\n  ",
        "\n  text-decoration: none;\n\n  &:not(:first-child) {\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledEditMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9eeb21f-0"
})(styles_templateObject(), function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? theme.global.primary_active_color : theme.location_card.border_color;
}, function(param) {
    var theme = param.theme;
    return theme.location_card.border_radius;
}, function(param) {
    var theme = param.theme;
    return theme.location_card.background_color;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* ORDER.STORE_CARD_MENU */.kl.STORE_CARD_MENU);
var StyledEditMenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b9eeb21f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER, css/* LinkHoverCss */.x, function(param) {
    var theme = param.theme;
    return theme.location_card.border_color;
});

;// CONCATENATED MODULE: ./src/components/account/storedAddresses/menu/index.tsx





var StoredAddressOptionsMenu = function(param) {
    var address = param.address;
    var dispatch = (0,es.useDispatch)();
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEditMenu, {
        children: [
            !address.default && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEditMenuButton, {
                onClick: function() {
                    return dispatch(actions/* default.defaultAddress */.Z.defaultAddress((ref = address === null || address === void 0 ? void 0 : address.id) !== null && ref !== void 0 ? ref : 0));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "account.addresses_default_button"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEditMenuButton, {
                onClick: function() {
                    return dispatch(actions/* default.deleteAddress */.Z.deleteAddress((ref1 = address === null || address === void 0 ? void 0 : address.id) !== null && ref1 !== void 0 ? ref1 : 0));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "account.addresses_delete_button"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/account/storedAddresses/styles.ts


function storedAddresses_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        "px;\n  position: relative;\n\n  &:not(:last-child) {\n    ",
        "\n  }\n"
    ]);
    storedAddresses_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -4px;\n  right: ",
        "px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledSpecialInstructions = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7293fe57-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontSize: "12px",
        marginTop: "20px"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ], {
        color: function(value) {
            return value ? (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)("0.1", value) : "inherit";
        }
    }));
});
var StyledAddressContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7293fe57-1"
})(storedAddresses_styles_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.checkout.border_color, ";\n  ");
});
var StyledAddressOptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7293fe57-2"
})(styles_templateObject1(), constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2);

// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
;// CONCATENATED MODULE: ./src/components/account/storedAddresses/index.tsx

function storedAddresses_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n"
    ]);
    storedAddresses_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var _StoredAddresses = function(param) {
    var myAddresses = param.myAddresses, fetchAddresses = param.fetchAddresses, toggleStoredAddressesMenu = param.toggleStoredAddressesMenu, setActiveStoredAddress = param.setActiveStoredAddress, theme = param.theme;
    var ref;
    // Don't show section if feature disabled
    if (!((ref = theme.accounts) === null || ref === void 0 ? void 0 : ref.stored_addresses)) {
        return null;
    }
    (0,react.useEffect)(function() {
        fetchAddresses();
        return function() {
            toggleStoredAddressesMenu(false);
            /** @TODO allow setting `null` addresses. */ // @ts-expect-error
            setActiveStoredAddress(null);
        };
    }, []);
    // Don't show section if no stored addresses
    if ((myAddresses === null || myAddresses === void 0 ? void 0 : myAddresses.length) < 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements/* StyledCheckoutComponent */.Sn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepHeader */.k$, {
                enabled: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    tag: uielements/* StyledHeaderText */.jc,
                    accessor: "account.addresses_header",
                    html: true
                })
            }),
            myAddresses.map(function(address) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAddressContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    address.default && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_uielements/* ConnectedStarIcon */.D, {}),
                                    address.street_address,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    address.street_address_2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            address.street_address_2,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        title: "".concat(address.id),
                                        children: address.city
                                    }),
                                    ",",
                                    " ",
                                    address.state,
                                    " ",
                                    address === null || address === void 0 ? void 0 : address.zip_code
                                ]
                            }),
                            address.special_instructions && /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: StyledSpecialInstructions,
                                accessor: "account.addresses_special_instructions_text",
                                html: true,
                                dataObj: {
                                    specialInstructions: address.special_instructions
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAddressOptionsContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Root */.fC, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Ellipsis */.Z.Ellipsis, {
                                                title: "Edit favorite location"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Content */.VY, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoredAddressOptionsMenu, {
                                                address: address
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, address.id);
            })
        ]
    });
};
var storedAddresses_mapStateToProps = function(state) {
    return {
        myAddresses: state.app.me.myAddresses
    };
};
var storedAddresses_mapDispatchToProps = {
    fetchAddresses: actions/* default.fetchAddresses */.Z.fetchAddresses,
    toggleStoredAddressesMenu: actions/* default.toggleStoredAddressesMenu */.Z.toggleStoredAddressesMenu,
    setActiveStoredAddress: actions/* default.setActiveStoredAddress */.Z.setActiveStoredAddress
};
var storedAddresses_connector = (0,es.connect)(storedAddresses_mapStateToProps, storedAddresses_mapDispatchToProps);
var StoredAddresses = (0,redux/* compose */.qC)(styled_components_browser_esm/* withTheme */.Zz, storedAddresses_connector)(_StoredAddresses);
var Edit = (0,styled_components_browser_esm/* default */.ZP)(dist/* Trigger */.xz).withConfig({
    componentId: "sc-41087307-0"
})(storedAddresses_templateObject());

// EXTERNAL MODULE: ../../node_modules/redux-form/es/Field.js + 10 modules
var Field = __webpack_require__(82415);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/getFormValues.js + 1 modules
var getFormValues = __webpack_require__(85428);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/reduxForm.js + 15 modules
var reduxForm = __webpack_require__(45900);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/index.ts + 2 modules
var form_fields = __webpack_require__(92682);
// EXTERNAL MODULE: ./src/validators/authValidators.ts
var authValidators = __webpack_require__(95228);
;// CONCATENATED MODULE: ./src/components/account/updatePassword/form.tsx












var UpdatePasswordForm = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(UpdatePasswordForm, Component);
    var _super = (0,_create_super/* default */.Z)(UpdatePasswordForm);
    function UpdatePasswordForm() {
        (0,_class_call_check/* default */.Z)(this, UpdatePasswordForm);
        var _this;
        _this = _super.apply(this, arguments);
        // @ts-expect-error improve form value typing.
        _this.handleSubmitForm = function(values) {
            _this.props.updateMe(values);
            _this.props.reset();
        };
        return _this;
    }
    var _proto = UpdatePasswordForm.prototype;
    _proto.render = function render() {
        var _props = this.props, handleSubmit = _props.handleSubmit, pristine = _props.pristine, reset = _props.reset;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledForm */.Gq, {
            onSubmit: handleSubmit(this.handleSubmitForm),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledInlineFormContainer */.fb, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledFormField */.Ll, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                name: "current_password",
                                type: "password",
                                placeholder: "Current Password",
                                autoComplete: "off",
                                component: form_fields/* ReduxFormField */.H
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledFormField */.Ll, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                name: "password",
                                type: "password",
                                placeholder: "New Password",
                                autoComplete: "off",
                                component: form_fields/* ReduxFormField */.H
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledFormField */.Ll, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                name: "password_confirmation",
                                type: "password",
                                placeholder: "Confirm New Password",
                                autoComplete: "off",
                                component: form_fields/* ReduxFormField */.H
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledCancelAndSubmitButtons */.VX, {
                    children: [
                        !pristine && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledCancelEdit */.Mo, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                                type: "button",
                                onClick: function() {
                                    return reset();
                                },
                                "aria-label": "Clear password form",
                                children: "Clear"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                            type: "submit",
                            theme: "secondary",
                            submitting: false,
                            handleClick: function() {
                                return null;
                            },
                            minWidth: 150,
                            "aria-label": "Submit Password Form",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "account.change_password_button"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return UpdatePasswordForm;
}(react.Component);
var form_mapStateToProps = function(state) {
    return {
        formValues: (0,getFormValues/* default */.Z)("update-password")(state)
    };
};
var form_connector = (0,es.connect)(form_mapStateToProps);
/* harmony default export */ var updatePassword_form = ((0,reduxForm/* default */.Z)({
    form: "update-password",
    validate: authValidators/* editUserValidator */.Pt
})(form_connector(UpdatePasswordForm)));

;// CONCATENATED MODULE: ./src/components/account/updatePassword/index.tsx










var PasswordInformation = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PasswordInformation, Component);
    var _super = (0,_create_super/* default */.Z)(PasswordInformation);
    function PasswordInformation() {
        (0,_class_call_check/* default */.Z)(this, PasswordInformation);
        return _super.apply(this, arguments);
    }
    var _proto = PasswordInformation.prototype;
    _proto.render = function render() {
        var _props = this.props, me = _props.me, updateMe = _props.updateMe;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements/* StyledCheckoutComponent */.Sn, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepHeader */.k$, {
                    enabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "account.change_password_header",
                        tag: uielements/* StyledHeaderText */.jc
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepContent */.rY, {
                    enabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(updatePassword_form, {
                        initialValues: me,
                        updateMe: updateMe
                    })
                })
            ]
        });
    };
    return PasswordInformation;
}(react.Component);
var updatePassword_mapStateToProps = function(state) {
    return {
        me: state.app.me.data
    };
};
var updatePassword_mapDispatchToProps = {
    updateMe: actions/* default.updateMe */.Z.updateMe
};
var updatePassword_connector = (0,es.connect)(updatePassword_mapStateToProps, updatePassword_mapDispatchToProps);
/* harmony default export */ var updatePassword = (updatePassword_connector(PasswordInformation));

// EXTERNAL MODULE: ../../node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(22601);
;// CONCATENATED MODULE: ./src/components/account/userBirthday/form.tsx

function form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  margin: "0px";\n'
    ]);
    form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











// Validation schema for the reset form.
var birthdaySchema = (0,yup_es/* object */.Ry)({
    birthday: (0,yup_es/* string */.Z_)().required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED)
});
var UserBirthdayForm = function(props) {
    var dispatch = (0,es.useDispatch)();
    var ref = (0,es.useSelector)(function(state) {
        return state.app.me;
    }), loading = ref.loading, data = ref.data;
    var readonly_fields = (0,es.useSelector)(function(state) {
        return state.app.organization.external_auth;
    }).readonly_fields;
    var userFields = readonly_fields.user;
    var handleBirthdaySubmit = function(formValues) {
        dispatch(actions/* default.updateMe */.Z.updateMe({
            birthday: formValues.birthday
        }));
    };
    var _birthday;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: function(formValues, param) {
            var resetForm = param.resetForm;
            handleBirthdaySubmit(formValues);
            resetForm();
            props.onCancel();
        },
        /** @TODO ensure that `data` is defined. */ // @ts-ignore
        initialValues: {
            birthday: (_birthday = data.birthday) !== null && _birthday !== void 0 ? _birthday : ""
        },
        validationSchema: birthdaySchema,
        children: function(param) {
            var dirty = param.dirty, isValid = param.isValid;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik/* Form */.l, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            "data-testid": "birthday-input",
                            autoFocus: true,
                            id: "birthday",
                            name: "birthday",
                            type: "date",
                            label: "",
                            width: "50%",
                            disabled: userFields.includes("birthday")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledInlineCancelAndSubmitButtons */.Dk, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledCancelEdit */.Mo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    onClick: props.onCancel,
                                    "aria-label": "Hide birthday form",
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                                type: "submit",
                                theme: "secondary",
                                disabled: !dirty || !isValid,
                                submitting: loading,
                                handleClick: function() {
                                    return null;
                                },
                                minWidth: 150,
                                "aria-label": "Submit Birthday",
                                children: loading ? "Loading" : "Submit"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var Link = (0,styled_components_browser_esm/* default */.ZP)(account_styles/* StyledLinkButton */.UN).withConfig({
    componentId: "sc-914ea729-0"
})(form_templateObject());

// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/components/account/userBirthday/index.tsx










var UserBirthday = function() {
    var ref = (0,react.useState)(false), displayBirthdayForm = ref[0], setDisplayBirthdayForm = ref[1];
    var ref1 = (0,react.useState)(false), birthdayDisabled = ref1[0], setBirthdayDisabled = ref1[1];
    var me = (0,src_redux/* useSelector */.v9)(function(root) {
        return root.app.me.data;
    });
    var birthdayWebConfig = (0,src_redux/* useSelector */.v9)(function(root) {
        return root.app.cmsConfig.webConfig.accounts.birthday;
    });
    var cancelEdit = function() {
        setDisplayBirthdayForm(false);
    };
    (0,react.useEffect)(function() {
        setBirthdayDisabled(birthdayWebConfig === "disabled");
    }, [
        birthdayWebConfig
    ]);
    if (birthdayDisabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements/* StyledCheckoutComponent */.Sn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepHeader */.k$, {
                enabled: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "account.birthday_header",
                    tag: uielements/* StyledHeaderText */.jc
                })
            }),
            (me === null || me === void 0 ? void 0 : me.birthday) && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledContactInfoContainer */.$3, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledContactInfoContent */.Ji, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,utils_dates/* formatDate */.p6)((0,date_fns_tz.zonedTimeToUtc)(me.birthday, (0,utils_dates/* getClientOffset */.QK)()), dates/* DATE_FORMAT.MONTH_DAY_YEAR */.z.MONTH_DAY_YEAR)
                        })
                    })
                })
            }),
            !(me === null || me === void 0 ? void 0 : me.birthday) && !displayBirthdayForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                onClick: function() {
                    return setDisplayBirthdayForm(true);
                },
                bold: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledContactInfoContainer */.$3, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "account.birthday_instructions"
                    })
                })
            }),
            !(me === null || me === void 0 ? void 0 : me.birthday) && displayBirthdayForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* StyledStepContent */.rY, {
                enabled: true,
                "data-testid": "birthday-form-step-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBirthdayForm, {
                    onCancel: cancelEdit
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/restrict/index.tsx
var restrict = __webpack_require__(40129);
// EXTERNAL MODULE: ./src/components/uielements/forms/index.ts
var uielements_forms = __webpack_require__(8658);
// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var auth_actions = __webpack_require__(45479);
;// CONCATENATED MODULE: ./pages/account/index.tsx





















var AccountPage = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AccountPage, Component);
    var _super = (0,_create_super/* default */.Z)(AccountPage);
    function AccountPage() {
        (0,_class_call_check/* default */.Z)(this, AccountPage);
        return _super.apply(this, arguments);
    }
    var _proto = AccountPage.prototype;
    _proto.render = function render() {
        var _props = this.props, logout = _props.logout, authLoading = _props.authLoading;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(restrict/* RestrictedAccountRoute */.Q, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
                backgroundOverride: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLoyaltyContainer */.t9, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(uielements_forms/* StyledPaddingContainer */.hX, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledFlexedHeader */.Pw, {
                                className: cssClassNames/* CSS_CLASSES.LOYALTY.PAGE_HEADER */.Y.LOYALTY.PAGE_HEADER,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        tag: "h2",
                                        accessor: "account.header",
                                        html: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton_styles/* StyledPrimaryButton */.D, {
                                        "aria-label": "Click to Sign Out",
                                        onClick: function() {
                                            return logout();
                                        },
                                        buttonTheme: "knockout",
                                        submitting: authLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "account.sign_out_button"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledAccountContainer */.aN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInformation, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountInformation, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoredAddresses, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBirthday, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(updatePassword, {})
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    return AccountPage;
}(react.Component);
var account_mapStateToProps = function(state) {
    return {
        authLoading: state.app.auth.loading
    };
};
var account_mapDispatchToProps = {
    logout: auth_actions/* default.logout */.Z.logout
};
var account_connector = (0,es.connect)(account_mapStateToProps, account_mapDispatchToProps);
/* harmony default export */ var account = ((0,redux/* compose */.qC)(account_connector, router.withRouter)(AccountPage));


/***/ }),

/***/ 84899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25167);


var PrimaryButton = function(param) {
    var children = param.children, theme = param.theme, type = param.type, submitting = param.submitting, handleClick = param.handleClick, minWidth = param.minWidth, disabled = param.disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_1__/* .StyledPrimaryButton */ .D, {
        buttonTheme: theme,
        type: type,
        submitting: submitting,
        minWidth: minWidth,
        onClick: handleClick,
        disabled: disabled,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrimaryButton);


/***/ }),

/***/ 95228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pt": function() { return /* binding */ editUserValidator; },
/* harmony export */   "a5": function() { return /* binding */ loginValidator; },
/* harmony export */   "f": function() { return /* binding */ guestUserValidator; }
/* harmony export */ });
/* harmony import */ var _utils_validation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78080);
/* harmony import */ var _constants_validation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38885);


var loginValidator = function(values) {
    var errors = {};
    if (!values.identifier) {
        errors.identifier = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.password) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.secret) {
        errors.secret = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    return errors;
};
var editUserValidator = function(values) {
    var errors = {};
    if (!values.first_name) {
        errors.first_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.last_name) {
        errors.last_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.email) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.email && !_constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX.EMAIL.test */ .mL.EMAIL.test(values.email)) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX_VALIDATION_STRINGS.EMAIL */ .r7.EMAIL;
    }
    if (!values.phone) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.phone && (0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__/* .invalidPhone */ .Dj)(values.phone)) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PHONE */ .xz.PHONE;
    }
    if (!values.zip_code) {
        errors.zip_code = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.zip_code && !_constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test */ .mL.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test(values.zip_code)) {
        errors.zip_code = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX_VALIDATION_STRINGS.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA */ .r7.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA;
    }
    if (values.password && values.password.length < 8) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PASSWORD_LENGTH */ .xz.PASSWORD_LENGTH;
    }
    if (values.password && values.password_confirmation !== values.password) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PASSWORD_MISMATCH */ .xz.PASSWORD_MISMATCH;
    }
    if (!values.password_confirmation) {
        errors.password_confirmation = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.password) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.current_password) {
        errors.current_password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    return errors;
};
var guestUserValidator = function(values) {
    var errors = {};
    if (!values.first_name) {
        errors.first_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.last_name) {
        errors.last_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.email) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.email && !_constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX.EMAIL.test */ .mL.EMAIL.test(values.email)) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX_VALIDATION_STRINGS.EMAIL */ .r7.EMAIL;
    }
    if (!values.phone) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.phone && (0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__/* .invalidPhone */ .Dj)(values.phone)) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PHONE */ .xz.PHONE;
    }
    return errors;
};


/***/ }),

/***/ 89785:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ $ea1ef594cf570d83$export$be92b6f5f03c0fe9; }
/* harmony export */ });
/* unused harmony export VisuallyHidden */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72714);







/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const $ea1ef594cf570d83$export$439d29a4e110a164 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_1__/* .Primitive.span */ .WV.span, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($ea1ef594cf570d83$export$439d29a4e110a164, {
    displayName: $ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;





//# sourceMappingURL=index.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,513,372,443,593,203,588,356,594,895,774,888,179], function() { return __webpack_exec__(32907); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);